import React from "react";
import { Checkbox, ControlLabel, FormGroup, FormControl } from "react-bootstrap";
import locale from "../../../../../locale";
import FormControlLanguage from "../../../../UI/FormControlLanguage";

const HallEpisodesBlockSettings = ({
    $locale,
    blockProperties,
    streams,
    onUpdateBlockProperties,
    onSave,
    onSaveStreams,
}) => {
    return (
        <>
            <FormGroup>
                <ControlLabel>{locale('settings.title')}</ControlLabel>
                <Checkbox
                    style={{marginTop: 0}}
                    checked={blockProperties?.showTitle ?? true}
                    onChange={(e) => onSave({showTitle: e.target.checked})}
                >
                    {locale('settings.showTitle')}
                </Checkbox>
            </FormGroup>
            {
                blockProperties?.showTitle &&
                <FormGroup>
                    <FormControlLanguage
                        type="text"
                        placeholder={locale('settings.placeholder.title')}
                        values={{
                            ru: blockProperties?.titleRu || '',
                            en: blockProperties?.titleEn || '',
                        }}
                        onChange={{
                            ru: (e) => onUpdateBlockProperties({titleRu: e.target.value}),
                            en: (e) => onUpdateBlockProperties({titleEn: e.target.value}),
                        }}
                        onBlur={() => onSave({
                            titleRu: blockProperties.titleRu,
                            titleEn: blockProperties.titleEn,
                        })}
                    />
                </FormGroup>
            }
            <Checkbox
                checked={blockProperties?.showModal ?? true}
                onChange={(e) => onSave({showModal: e.target.checked})}
            >
                {locale('program.modals.show')}
            </Checkbox>
            <FormGroup>
                <ControlLabel>{locale('settings.pixelsInMinute')}</ControlLabel>
                <FormControl
                    type="text"
                    value={blockProperties?.pixelsInMinute?.toString() ?? ''}
                    onChange={(e) => onUpdateBlockProperties({pixelsInMinute: parseInt(e.target.value || 0)})}
                    onBlur={() => onSave({
                        pixelsInMinute: blockProperties.pixelsInMinute,
                    })}
                />
            </FormGroup>
            <FormGroup>
                <ControlLabel>{locale('settings.scheduleButton')}</ControlLabel>
                <Checkbox
                    style={{marginTop: 0}}
                    checked={blockProperties?.showScheduleButton ?? true}
                    onChange={(e) => onSave({showScheduleButton: e.target.checked})}
                >
                    {locale('settings.scheduleButton.show')}
                </Checkbox>
            </FormGroup>
            {
                blockProperties?.showScheduleButton &&
                <FormGroup>
                    <FormControlLanguage
                        type="text"
                        placeholder={locale('settings.scheduleButton.title')}
                        values={{
                            ru: blockProperties?.scheduleButtonTitleRu || '',
                            en: blockProperties?.scheduleButtonTitleEn || '',
                        }}
                        onChange={{
                            ru: (e) => onUpdateBlockProperties({scheduleButtonTitleRu: e.target.value}),
                            en: (e) => onUpdateBlockProperties({scheduleButtonTitleEn: e.target.value}),
                        }}
                        onBlur={() => onSave({
                            scheduleButtonTitleRu: blockProperties.scheduleButtonTitleRu,
                            scheduleButtonTitleEn: blockProperties.scheduleButtonTitleEn,
                        })}
                    />
                </FormGroup>
            }
            <hr />
            {
                !!streams.length &&
                <>
                    <ControlLabel>{locale('settings.show.block.displayHall')}</ControlLabel>
                    {
                        streams.map((stream) => (
                            <Checkbox
                                key={stream.id}
                                style={{marginTop: 0}}
                                value={stream.id}
                                checked={blockProperties?.showInStreams?.includes(stream.id)}
                                onChange={(e) => onSaveStreams(stream.id, e.target.checked)}
                            >
                                {stream[`description_${$locale.localeName}`]}
                            </Checkbox>
                        ))
                    }
                </>
            }
        </>
    );
};

export default HallEpisodesBlockSettings;
